import { render, staticRenderFns } from "./HealthBleed.vue?vue&type=template&id=23ad5a1e&scoped=true"
import script from "./HealthBleed.vue?vue&type=script&lang=js"
export * from "./HealthBleed.vue?vue&type=script&lang=js"
import style0 from "./HealthBleed.vue?vue&type=style&index=0&id=23ad5a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad5a1e",
  null
  
)

export default component.exports